import { toast } from 'sonner';

/**
 * Непрочитанная сохранённая запись НЕ проглатывается тихо.
 *
 * Перенос идеи донора (PRO100-онлайн, `src/ui/DraftRecoveryDialog.tsx`): «черновик не
 * прочитался» — разговор с человеком, а не молчаливая подмена демо-сценой/чистым стартом. У нас
 * нет донорского `WorkingDraftStore` (свой формат черновика, quarantine-ключ, восстановление
 * файлом целиком) — переносить его нечего дословно, но САМ БАГ, который он чинит, у нас есть в
 * двух местах, и оба найдены не предположением, а чтением кода:
 *
 * 1. `shared/store/viewer-store.ts` / `ui-store.ts` — zustand 5.0.14 `persist`. Ошибку
 *    гидратации (порченый JSON в localStorage, упавшая `migrate()`) middleware ловит в `.catch`
 *    и передаёт в `onRehydrateStorage`-колбэк — а колбэк по умолчанию не задан
 *    (`node_modules/zustand/esm/middleware.mjs`, `hydrate()`). Без колбэка `.catch` не делает
 *    ничего: стор молча остаётся на дефолтных значениях (`activeModelId: null`), и человек не
 *    узнаёт, что последняя открытая модель или раскладка панелей исчезли.
 * 2. `features/recognition-arm/recognition-arm-api.ts` — `RecognitionArmCoordinator.recover()`
 *    читает указатель на незавершённое задание распознавания из localStorage. При ошибке
 *    `JSON.parse` код ЛОВИЛ исключение, СТИРАЛ запись (`localStorage.removeItem`) и возвращал
 *    `null` — то есть незавершённое задание тихо исчезало НАВСЕГДА в тот момент, когда его
 *    прочитать не вышло, и рабочая область открывалась с чистого листа без единого слова.
 *
 * Разница масштаба с донором: там отложенная запись — единственная копия чьей-то работы, поэтому
 * там целый диалог со скачиванием и явным «выбросить». У нас потерянная сохранённая запись —
 * это либо ПРЕДПОЧТЕНИЯ ПРОСМОТРА (модель по-прежнему лежит на сервере), либо ссылка НА задание,
 * которое тоже живёт на сервере (не сама работа). Соразмерный ответ — не диалог восстановления
 * файлом (нечего восстанавливать текстом: строка испорчена и уже нечитаема), а ВИДИМОЕ
 * уведомление вместо тишины и запись, оставленная на месте, а не стёртая раньше, чем человек
 * о ней узнал.
 */
export function describeUnreadableSavedState(label: string, error: unknown): string {
  const reason = error instanceof Error ? error.message : String(error);
  return `Сохранённая запись «${label}» не прочиталась (${reason}) — работа продолжится с чистого листа.`;
}

/** Console — для разработчика; toast — для человека за экраном. Ни один канал не заменяет
 *  другой: `console.error` не гарантированно кто-то смотрит, а тост не переживает reload. */
export function reportUnreadableSavedState(label: string, error: unknown): void {
  const message = describeUnreadableSavedState(label, error);
  // eslint-disable-next-line no-console
  console.error(`[saved-state:${label}] unreadable`, error);
  toast.error(message);
}
